import Button from '@mui/material/Button'

/*
 * `sx` is destructured out of props and merged rather than spread last.
 * Previously any caller supplied `sx` landed after the internal one via
 * {...props} and replaced it outright, silently discarding the named
 * props (borderRadius, width, height, and so on). Every current caller
 * either passes no sx or passes one that sets properties the internal
 * object left undefined, so merging is visually identical here.
 */
export default function ButtonComponent ({
  variant,
  text,
  borderRadius,
  backgroundColor,
  width,
  type,
  color,
  height,
  fontFamily,
  sx,
  ...props
}) {
  return (
    <Button
      type={type}
      variant={variant}
      sx={{
        borderRadius,
        color,
        backgroundColor,
        width,
        height,
        fontFamily,
        ...sx
      }}
      {...props}
    >{text}
    </Button>
  )
}
